import * as types from './actionTypes';
import initialState from 'reducers/initialState';
import { OFFER_PARTNER_UPDATED } from 'features/offer/edit/client/form/eventTypes';
import { OFFER_ASSET_CLIENT_UPDATED, OFFER_ASSET_CLIENT_INVALIDATED } from 'features/offer/edit/assets/client/eventTypes';

export default function reducer(state = initialState.currentOffer.assetClientData, action) {
  switch (action.type) {
    case types.LOAD_OFFER_ASSET_CLIENT_SUCCEEDED:
      return {
        ...state,
        client: {
          ...state.client,
          partnerId: action.payload.client.partnerId,
          isLoaded: true
        }
      };

    case types.SAVE_OFFER_ASSET_CLIENT_STARTED:
      return {
        ...state,
        saving: true
      };

    case types.SAVE_OFFER_ASSET_CLIENT_SUCCEEDED: {
      const { documentId, siteId, partnerId } = action.payload;
      return {
        ...state,
        client: { ...state.client, partnerId, documentId, siteId, isLoaded: true },
        saving: false
      };
    }

    case types.SAVE_OFFER_ASSET_CLIENT_FAILED:
      return {
        ...state,
        saving: false
      };

    case types.PRINTING_GDPR_STARTED:
      return {
        ...state,
        printingGdpr: true
      };

    case types.PRINTING_GDPR_SUCCEEDED:
      return {
        ...state,
        printingGdpr: false
      };

    case types.PRINTING_GDPR_FAILED:
      return {
        ...state,
        printingGdpr: false
      };

    case types.TOGGLE_OFFER_ASSET_CLIENT_CARD:
      return {
        ...state,
        expanded: action.payload.expanded
      };

    case types.CANCEL_OFFER_ASSET_CLIENT_CHANGES:
      return {
        ...state,
        client: {
          ...state.client,
          loadedByUniqueId: null
        }
      };

    case OFFER_ASSET_CLIENT_UPDATED: {
      const { clientId } = action.event.eventBody;

      return {
        ...state,
        client: {
          ...state.client,
          partnerId: clientId,
          isLoaded: false
        }
      };
    }

    case OFFER_ASSET_CLIENT_INVALIDATED: {
      const { clientId } = action.event.eventBody;

      return {
        ...state,
        client: {
          ...state.client,
          partnerId: clientId,
          isLoaded: false
        }
      };
    }

    case OFFER_PARTNER_UPDATED: {
      const { isAssociatedPartner, partnerId } = action.event.eventBody;
      if (isAssociatedPartner) {
        return state;
      } else {
        return {
          ...state,
          client: {
            ...state.client,
            partnerId,
            isLoaded: false
          }
        };
      }
    }

    case types.LOAD_OFFER_ASSET_CLIENT_BY_ID_STARTED: {
      return {
        ...state,
        client: {
          ...state.client,
          loading: true,
          loaded: false
        }
      };
    }

    case types.LOAD_OFFER_ASSET_CLIENT_BY_ID_FAILED: {
      return {
        ...state,
        client: {
          ...state.client,
          loading: false,
          loaded: false
        }
      };
    }

    case types.LOAD_OFFER_ASSET_CLIENT_BY_ID_SUCCEEDED: {
      const { uniqueId, withErrors } = action.payload;
      return {
        ...state,
        client: {
          ...state.client,
          loadedByUniqueId: uniqueId,
          loaded: true,
          withErrors,
          loading: false
        }
      };
    }
    default:
      return state;
  }
}
